import React from 'react';
import Filter from './context';
import getChildren from '../../utils/children';

const FilterBlock = ({ itemContext, content }) => <Filter itemContext={itemContext}>{getChildren(content)}</Filter>;

export default FilterBlock;
